import { useEffect, useState } from "react"
import InvoicesStarter from "../components/InvoicesStarter"
import axios from "axios"
import api from "../config/backend"
import { toast } from "react-toastify"
import "./css/Invoices.css"
import CreateInvoice from "../components/CreateInvoice"
import InvoicesList from "../components/InvoicesList"
import { SpinnerCircular } from "spinners-react"

const Invoices = () => {
    const [createInvoice, setCreateInvoice] = useState(false)
    const [invoicesList, setInvoicesList] = useState([])
    const [loading, setLoading] = useState(true)

    const token = localStorage.getItem("_crm__token")

    const fetchInvoices = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/invoices-list`, { token })

        setLoading(false)

        if (data.success) {
            setInvoicesList(data.invoices)
        }
        else {
            toast.error(data.message)
        }
    }

    useEffect(() => {
        fetchInvoices()
    }, [])

    if (createInvoice) {
        return <CreateInvoice setInvoicesList={setInvoicesList} setCreateInvoice={setCreateInvoice} />
    }

    if (loading) {
        return (
            <div className="_5dut">
                <SpinnerCircular size="60" color="#3b70ad" />
            </div>
        )
    }

    if (invoicesList.length) {
        return (
            <InvoicesList invoicesList={invoicesList} setCreateInvoice={setCreateInvoice} />
        )
    }

    // New user - no invoices created
    return (
        <InvoicesStarter setCreateInvoice={setCreateInvoice} />
    )
}

export default Invoices

